export default __webpack_public_path__ + "static/2.3-73602ba928e93ce221699e35eeed8bda.webp";